module.exports = "./img/27093923bac8a7960ad6f9f3a00dfadb.jpg";